function getClosestAccordion(el) {
  return el && (el.matches('[data-component="TreeView"]') ? el : getClosestAccordion(el.parentElement));
}
function getSiblingButtons(item) {
  const parentAccordion = getClosestAccordion(item);
  return parentAccordion && Array.from(parentAccordion.querySelectorAll('[data-component="TreeViewItem"]'));
}
function focusNextSiblingOf(item) {
  const siblings = getSiblingButtons(item) || [];
  const currentIndex = siblings.indexOf(item);
  if (currentIndex !== -1) {
    const next = siblings[currentIndex + 1];
    if (next) {
      next.focus();
    }
  }
}
function focusPreviousSiblingOf(item) {
  const siblings = getSiblingButtons(item) || [];
  const currentIndex = siblings.indexOf(item);
  if (currentIndex !== -1) {
    const previous = siblings[currentIndex - 1];
    if (previous) {
      previous.focus();
    }
  }
}

export { focusNextSiblingOf, focusPreviousSiblingOf, getClosestAccordion, getSiblingButtons };
